// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarDays16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-days': IconCalendarDays;
    }
}

/**
 * The icon component for the 'calendarDays' icon
 */
export class IconCalendarDays extends Icon {
    public constructor() {
        super(calendarDays16X16);
    }
}

registerIcon('icon-calendar-days', IconCalendarDays);
export const iconCalendarDaysTag = 'nimble-icon-calendar-days';
